
class MainProduct extends HTMLElement {
  variantPicker; btn; feedback;
  static selectors = {
    add: '[data-add]',
  };

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.saveViewed();
    this.variantPicker = this.querySelector('variant-picker');
    this.btn = this.querySelector(MainProduct.selectors.add);

    if(this.variantPicker != undefined){
      this.variantPicker.addEventListener(Utils.VARIANT_CHANGED, (e, data) => {
        this.refreshVariant(e.detail.variant);
      });
    }
    if(this.btn != undefined){
      this.btn.addEventListener('click', () => {
        this.addToCart();
      });
    }
    window.addEventListener(Utils.CART_ADDED, () => {
      this.refreshProduct();
    });
  }

  refreshProduct = () => {
    window.pageLoader.open();
    axios.get(location.href).then((response) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(response.data, 'text/html');
      this.innerHTML = doc.querySelector('main-product').innerHTML;
      this.init();
      activateTooltips();      
    })
    .catch(function(error) {
      Utils.error(error.message, error);
    })
    .finally(() => {
      window.pageLoader.close();
    });
  }

  refreshVariant = (variant) => {
    window.pageLoader.open();
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    axios.get(url.href).then((response) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(response.data, 'text/html');
      this.innerHTML = doc.querySelector('main-product').innerHTML;
      this.setUrl(variant.id);
      this.init();
      activateTooltips();      
    })
    .catch(function(error) {
      Utils.error(error.message, error);
    })
    .finally(() => {
      window.pageLoader.close();
    });
  }

  setUrl = (variantid) => {
    const params = new URLSearchParams(window.location.search);
    const title = document.querySelector('title').innerText;
    params.set('variant', variantid);
    window.history.replaceState({}, title, `${window.location.pathname}?${params}`);
  }

  addToCart = () => {
    Utils.addTocart({
      form: this.querySelector('form'),
      beforeAdd: (id) => {
        window.pageLoader.open();
      },
      finally: () => {
        window.pageLoader.close();
      }
    });
  }

  saveViewed = () => {
    if(!this.isViewed()){
      const viewed = Utils.getViewed();
      viewed.forEach((item) => {
        if(item == this.dataset.handle){
          return;
        }
      });
      viewed.unshift(this.dataset.handle);
      localStorage.setItem(Utils.VIEWED, viewed.join(','));
      window.dispatchEvent(new CustomEvent(Utils.PRODUCT_VIEWED_FIRST, { detail: this.dataset.handle }));
    }
  }

  isViewed = () => {
    const viewed = Utils.getViewed();
    var found = false;
    viewed.forEach((item) => {
      if(item == this.dataset.handle){
        found = true;
        return;
      }
    });
    return found;
  }
  
}
if (!window.customElements.get("main-product")) {
  window.customElements.define("main-product", MainProduct);
}